/**
 * PD-16594 — Text Message Senders: which of a tenant's own phone numbers each kind of
 * AUTOMATED text is sent from. Texts a person sends from the communications panel keep
 * using that person's number; this covers only what Workd sends on the tenant's behalf.
 *
 * A kind with no number (null) goes out from Workd's shared number, which is what every
 * automated text used before this setting existed.
 */
export const SMS_SENDER_KINDS = ['sign_in', 'welcome', 'delivery'] as const;

export type SmsSenderKind = (typeof SMS_SENDER_KINDS)[number];

export interface SmsSenderKindInfoModel {
	label: string;
	description: string;
}

export const SMS_SENDER_KIND_INFO: Readonly<
	Record<SmsSenderKind, SmsSenderKindInfoModel>
> = {
	sign_in: {
		label: 'Sign-in codes and password resets',
		description:
			'The one-time codes and links people receive when they sign in or reset a password by text.',
	},
	welcome: {
		label: 'Welcome texts',
		description:
			'The text a new storefront or CRM user receives when their account is created with a welcome text.',
	},
	delivery: {
		label: 'Delivery notifications',
		description:
			'The "your delivery is on the way" text sent to a customer when a driver starts toward their stop.',
	},
};

/** The phone number each kind is sent from, in E.164; null = Workd's shared number. */
export type SmsSendersSettingModel = Record<SmsSenderKind, string | null>;

export const DEFAULT_SMS_SENDERS: Readonly<SmsSendersSettingModel> = {
	sign_in: null,
	welcome: null,
	delivery: null,
};

/** E.164: a plus, a country code that does not start with 0, up to 15 digits in all. */
export const E164_PATTERN = /^\+[1-9]\d{6,14}$/;
